import React from 'react'
import footerimage from '../images/Zing_footer.png'
const Footer = () => {
  return (
    <div>
        <div className='row mt-2'>
            <div className='d-flex justify-content-end'>
                <img src={footerimage} alt='Bee_innovation' style={{width:'180px'}} />
            </div>

        </div>
      
    </div>
  )
}

export default Footer
